import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import CompanyUserMenu from "./UsersMenu";

const CompanyUserCard = ({
  user,
  currentCompanyUser,
  setSelectedUser,
  allUsers,
  setOpen,
  setMode,
  setUsers,
  setSnackbarMessage,
  setSnackbarOpen,
  companyRoleKey,
}) => {
  return (
    <Card
      sx={{
        width: "345px",
        height: "260px",
        border: "1px solid #000",
        padding: 0,
        borderRadius: 0,
        position: "relative",
      }}
    >
      <CardContent
        sx={{
          width: "100%",
          height: "100%",
          padding: 0,
          position: "relative",
        }}
      >
        {/* メニューアイコン（右上） adminは全員分、それ以外は自分のデータのみ表示 */}
        {(currentCompanyUser?.role === "admin" || currentCompanyUser?.id === user.id) && (
          <Box sx={{ textAlign: "right", mr: "12px", mt: "10px" }}>
            <CompanyUserMenu
              companyUserId={user.id}
              user={user}
              currentCompanyUser={currentCompanyUser}
              allUsers={allUsers}
              setSelectedUser={setSelectedUser}
              setOpen={setOpen}
              setMode={setMode}
              setUsers={setUsers}
              setSnackbarMessage={setSnackbarMessage}
              setSnackbarOpen={setSnackbarOpen}
            />
          </Box>
        )}
        {/* ユーザー情報本体 */}
        <Box
          sx={{
            position: "absolute",
            top: "37px",
            px: "43px",
            display: "flex",
            flexDirection: "column",
            gap: "6px",
          }}
        >
          <Typography sx={{ fontSize: "14px" }}>{user.number}</Typography>
          <Typography sx={{ fontSize: "14px" }}>
            {user.last_name_kana} {user.first_name_kana}
          </Typography>
          <Typography sx={{ fontSize: "20px" }}>
            {user.last_name} {user.first_name}
          </Typography>
          <Typography sx={{ fontSize: "14px" }}>{user.email}</Typography>
          {companyRoleKey === "management" && (
            <Typography sx={{ fontSize: "14px" }}>
              {user.department_name || "（未設定）"}
            </Typography>
          )}
          {(() => {
            const pr = user.pr_text ?? "";
            const hasPr = pr.trim().length > 0;

            return (
              <Tooltip
                title={
                  hasPr ? (
                    <Box sx={{ whiteSpace: "pre-wrap" }}>{pr}</Box>
                  ) : undefined
                }
                arrow
                placement="top-start"
                disableHoverListener={!hasPr}
                enterTouchDelay={50}
                leaveTouchDelay={4000}
                slotProps={{
                  tooltip: {
                    sx: {
                      bgcolor: "#111",
                      color: "#fff",
                      fontSize: 13,
                      maxWidth: 360,
                      p: 1.25,
                      borderRadius: 1.5,
                    },
                  },
                  arrow: { sx: { color: "#111" } },
                }}
              >
                <Typography
                  tabIndex={hasPr ? 0 : -1}
                  sx={{
                    fontSize: "14px",
                    lineHeight: 2,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    cursor: "default",
                  }}
                >
                  {hasPr ? pr : "　"}
                </Typography>
              </Tooltip>
            );
          })()}
        </Box>
      </CardContent>
    </Card>
  );
};

export default CompanyUserCard;
